import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'

export class ActionNode extends BaseNode {
    next = NodeType.Character
    enableSuggestions = false

    static getType(): string {
        return 'action'
    }

    static clone(node: ActionNode): ActionNode {
        return new ActionNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const div = document.createElement('div')
        div.className = 'action node-style-common avoid-page-break'
        return div
    }

    static importJSON(jsonNode: SerializedBaseNode): ActionNode {
        return new ActionNode(jsonNode.id)
    }
}
